import { DesignerColor, newDesignerColor } from '@decisions/server/Decisions/Silverlight/UI/Utilities';

interface ColorPickerOptions {
  pickedColor?: DesignerColor | string;
  ShowGradients?: boolean;
}

export interface ColorPickerDialogOptions {
  stickTo: HTMLElement;
  title?: string;
  width?: number;
  height?: number;
  onOk?: (designerColor: DesignerColor) => void;
  onClosed?: () => void;
  onClear?: () => void;
}

export interface ILegacyColorPickerOptions extends ColorPickerOptions, ColorPickerDialogOptions {}

export const LegacyColorPicker = {
  showLegacyColorPickerDialog,
};

export function showLegacyColorPickerDialog(options: ILegacyColorPickerOptions) {
  if (typeof options.pickedColor === 'string') {
    options.pickedColor = newDesignerColor({
      ColorName: options.pickedColor,
      GradientDirection: 0,
      Opacity: 0,
      Type: 0,
    });
  }
  const colorDialog = new $DP.ColorDialogEditor.ColorPicker(options);
  $DP.ColorDialogEditor.showColorPickerDialog(colorDialog, options);
}
